<script>
    import LiteCompareMobileProduct from "./LiteCompareMobileProduct";
    import LiteCompareHeaderMobileProduct from "./LiteCompareHeaderMobileProduct";
    import LiteCompareHeaderMobile from "./LiteCompareHeaderMobile";

    export default {
        name: "LiteCompareMobile",
        components: {
            LiteCompareHeaderMobile,
            LiteCompareHeaderMobileProduct,
            LiteCompareMobileProduct,
        },
        props: {
            products: {
                type: Array,
                required: true,
                default: () => [],
            },
            specifications: {
                type: Array,
                required: true,
            },
            imagesList: Object,
            inCartList: Array,
            showColorsList: Boolean,
            colorsListSize: String,
            topMargin: Number,
            startPosition: Number,
        },
        data() {
            return {
                firstCard: 1,
                secondCard: 2,
            };
        },
        methods: {
            firstArrowHandler(pos) {
                if (pos === "prev") {
                    if (this.secondCard === this.firstCard - 1) {
                        this.firstCard--;
                    }

                    this.firstCard--;
                    if (this.firstCard === 0) {
                        this.firstCard = this.products.length;
                    }
                }
                if (pos === "next") {
                    if (this.secondCard === this.firstCard + 1) {
                        this.firstCard++;
                    }

                    this.firstCard++;
                    if (this.firstCard === this.products.length + 1) {
                        this.firstCard = 1;
                    }
                }
            },
            secondArrowHandler(pos) {
                if (pos === "prev") {
                    this.secondCard--;

                    if (this.secondCard === this.firstCard) {
                        this.secondCard = this.firstCard - 1;
                    }

                    if (this.secondCard === 0) {
                        this.secondCard = this.products.length;
                        if (this.secondCard === this.firstCard) {
                            this.secondCard = this.firstCard - 1;
                        }
                    }
                }

                if (pos === "next") {
                    this.secondCard++;

                    if (this.secondCard === this.firstCard) {
                        this.secondCard = this.firstCard + 1;
                    }

                    if (this.secondCard === this.products.length + 1) {
                        this.secondCard = 1;
                        if (this.secondCard === this.firstCard) {
                            this.secondCard = this.firstCard + 1;
                        }
                    }
                }
            },
        },
    };
</script>

<template>
    <div class="lite-compare-mobile">
        <lite-compare-header-mobile
            :products="products"
            :images-list="imagesList"
            :start-position="startPosition"
        >
            <div class="lite-compare-mobile__products">
                <lite-compare-header-mobile-product
                    v-for="(product, index) in products"
                    :key="'first_header_' + index"
                    v-show="firstCard === index + 1"
                    :position="firstCard - 1"
                    :product="product"
                    :products-length="products.length"
                    :images-list="imagesList"
                    :first-card-position="firstCard"
                    is-first
                    @on-click-arrow="firstArrowHandler"
                ></lite-compare-header-mobile-product>

                <lite-compare-header-mobile-product
                    v-for="(product, index) in products"
                    :key="'second_header_' + index"
                    v-show="secondCard === index + 1"
                    :position="secondCard - 1"
                    :product="product"
                    :products-length="products.length"
                    :images-list="imagesList"
                    :second-card-position="secondCard"
                    @on-click-arrow="secondArrowHandler"
                ></lite-compare-header-mobile-product>
            </div>
        </lite-compare-header-mobile>

        <div class="lite-compare-mobile__products">
            <lite-compare-mobile-product
                v-for="(product, index) in products"
                :key="'first_' + index"
                v-show="firstCard === index + 1"
                :position="firstCard - 1"
                :product="product"
                :products-length="products.length"
                :specifications="specifications"
                :in-cart-list="inCartList"
                :images-list="imagesList"
                :first-card-position="firstCard"
                :show-colors-list="showColorsList"
                :colors-list-size="colorsListSize"
                is-first
                @on-click-arrow="firstArrowHandler"
            ></lite-compare-mobile-product>

            <lite-compare-mobile-product
                v-for="(product, index) in products"
                :key="'second_' + index"
                v-show="secondCard === index + 1"
                :position="secondCard - 1"
                :product="product"
                :products-length="products.length"
                :specifications="specifications"
                :in-cart-list="inCartList"
                :images-list="imagesList"
                :second-card-position="secondCard"
                :show-colors-list="showColorsList"
                :colors-list-size="colorsListSize"
                @on-click-arrow="secondArrowHandler"
            ></lite-compare-mobile-product>
        </div>
    </div>
</template>

<style lang="scss">
    .lite-compare-mobile {
        position: relative;
    }

    .lite-compare-mobile__products {
        display: flex;
    }
</style>
